import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/26d8c27b87decb516fa51c337abf97bb.jpeg" 
              alt="ESAPCOR Logo" 
              className="h-14 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('benefits')}
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Lợi Ích
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Bảng Giá
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Quy Trình
            </button>
            <button
              onClick={() => scrollToSection('qrcode')}
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Đăng Ký
            </button>
            <button
              onClick={() => scrollToSection('qrcode')}
              className="whitespace-nowrap px-6 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Nhận Ưu Đãi Ngay
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}